import React, { useContext, useState } from 'react'
import { GlobalContext } from '../../context/provider'
import sell_invoice_ledgeraction from '../../context/action/item/sell_invoice_ledgeraction';
import Item_sell_invoice_ledger from './item_sell_invoice_ledger';
import buy_invoice_ledgeraction from '../../context/action/item/buy_invoice_ledgeraction';
import Item_buy_invoice_ledger from './item_buy_invoice_ledger';
import ledgeraction from '../../context/action/item/ledgeraction';
import Item_ledger_table from './item_ledger_table';
import Itemsummary from './itemsummary';
import summaryaction from '../../context/action/item/summaryaction';

const Itemledger = () => {
    const {initState, clear} = useContext(GlobalContext);
    
    const [sell_invoice,setsell_invoice]=useState([]);
    const [buy_invoice,setbuy_invoice]=useState([]);
    const [ledger,setledger]=useState([]);
    const [summary,setsummary]=useState({});
    const [table_type,settable_type]=useState('');
    var item_id = initState?.ledger_item_id;
    var item_code = initState?.ledger_item_code;
    var item_name = initState?.ledger_item_name;
    return (
        <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-slate-50">
            <div className="w-full h-16 sm:h-20 lg:h-24 flex justify-center items-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-4 sm:mb-6">
                 تۆمارەکانی کاڵای - {item_name} ({item_code})
            </div>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    sell_invoice_ledgeraction(item_id)(clear).then((res)=>{
                        setsell_invoice(res);
                        settable_type('sell_invoice');
                    });
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        وەسڵی فرۆشراو
                    </h5>
                </div>
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    buy_invoice_ledgeraction(item_id)(clear).then((res)=>{
                        setbuy_invoice(res);
                        settable_type('buy_invoice');
                    }); 
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        وەسڵی کڕدراو
                    </h5>
                </div>
            </div>
            <div className="flex flex-col mt-10 sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    ledgeraction(item_id)(clear).then((res)=>{
                        setledger(res);
                        settable_type('ledger');
                    });
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        کەشف حساب
                    </h5>
                </div>
                <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
                    summaryaction(item_id)(clear).then((res)=>{
                        setsummary(res);
                        settable_type('summary');
                        console.log(res);
                    });
                }}>
                    <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                        پوختە
                    </h5>
                </div>
            </div>
            <div className="mt-6 sm:mt-8 lg:mt-10">
                {table_type=="sell_invoice"?<Item_sell_invoice_ledger sell_invoice={sell_invoice} />:table_type=="buy_invoice"?<Item_buy_invoice_ledger invoice={buy_invoice} />:table_type=="ledger"?<Item_ledger_table ledger={ledger} />:table_type=="summary"?<Itemsummary {...summary} />:null}
            </div>
        </div>
    )
}

export default Itemledger